import { Component, Input, OnInit } from '@angular/core';
import { JobScreenContactPeopleTask } from '../../../../interfaces/screen-specific/job-screen';

@Component({
  selector: 'job-screen-contact-people',
  templateUrl: './job-screen-contact-people.component.html',
  styleUrls: ['./job-screen-contact-people.component.scss', '../../common/job-screen-common.scss'],
})
export class JobScreenContactPeopleComponent implements OnInit {
  @Input('organisationTypeId') organisationTypeId!: number;
  @Input('contactPeopleTask') contactPeopleTask!: JobScreenContactPeopleTask;

  constructor() {}
  ngOnInit(): void {}
}
